import TotalLabel from './TotalLabel';



export default TotalLabel;
